<script>
import HomePageBanner from './ISEF/HomePageBanner'
import FinalistBanner from './ISEF/FinalistBanner'

export default {
  components: {
    HomePageBanner,
    FinalistBanner
  },
  computed: {
    isExplorer: function () {
      return this.$route.name === 'viewAll'
    },
    isHome: function () {
      return this.$route.name === 'home'
    },
    isCategories: function () {
      return this.$route.name === 'viewAll' && !this.$route.query.awardID
    },
    isLanding: function () {
      return this.$route.path === '/'
    }
  }
}
</script>

<template>
  <section :class="{ 'isef-banner' : isCategories || isLanding }">
    <HomePageBanner v-if="!isExplorer && !isHome"/>
    <FinalistBanner v-else/>
  </section>
</template>

<style lang="scss" scoped>
@import '~styles/utils.scss';
@import '~@/styles/projectboard-mixins';

.isef-banner {
  @media only screen and (max-width: 600px) {
    padding-top: 4rem;
  }
}
</style>
